import React, { Component, Fragment } from 'react'
import { Button, TableRow, TableCell } from '@material-ui/core'

// utils
import { onChangeEditHOF } from '../../utils/common'
import { hasAccess } from '../../utils/api'

import { EditableTextField, EditableSwitch } from '../common/EditableComponents'
import EditActionComponent from '../common/EditActionComponent'

export default class ShopListItem extends Component {
  onChange = onChangeEditHOF(this.props.onChange)

  onSave = () => {
    this.props.onSave((response) => this.props.disableEdit())
  }

  onCancel = () => {
    this.props.onCancel()
  }

  render() {
    const { data, editMode } = this.props

    return (
      <TableRow>
        <TableCell className="cell-wrap-word">
          <EditableTextField
            valueToRender={data.name}
            editMode={editMode}
            value={data.name}
            onChange={this.onChange('name')}
            type="text"
            InputLabelProps={{
              shrink: true,
            }}
          />
        </TableCell>
        <TableCell className="cell-wrap-word">
          <EditableTextField
            valueToRender={data.startWeight}
            editMode={editMode}
            value={data.startWeight}
            onChange={this.onChange('startWeight')}
            type="number"
            InputLabelProps={{
              shrink: true,
            }}
          />
        </TableCell>
        <TableCell className="cell-wrap-word">
          <EditableTextField
            valueToRender={data.endWeight}
            editMode={editMode}
            value={data.endWeight}
            onChange={this.onChange('endWeight')}
            type="number"
            InputLabelProps={{
              shrink: true,
            }}
          />
        </TableCell>
        <TableCell className="cell-wrap-word">
          <EditableTextField
            valueToRender={data.unitValue}
            editMode={editMode}
            value={data.unitValue}
            onChange={this.onChange('unitValue')}
            type="number"
            InputLabelProps={{
              shrink: true,
            }}
          />
        </TableCell>
        <TableCell className="cell-wrap-word">
          <EditableSwitch
            valueToRender={data.enabled ? 'Enabled' : 'Not Enabled'}
            checked={data.enabled}
            editMode={editMode}
            onChange={this.onChange('enabled', true)}
          />
        </TableCell>
        {hasAccess() ? (
          <TableCell className="cell-wrap-word">
            <Fragment>
              <EditActionComponent
                onSave={this.onSave}
                onCancel={this.onCancel}
                onEdit={this.props.enableEdit}
                editMode={editMode}
              />
              {!editMode && data.weightKey === 'CUSTOM' ? (
                <Button className="danger-button margin" onClick={this.props.onDelete}>
                  Delete
                </Button>
              ) : null}
            </Fragment>
          </TableCell>
        ) : null}
      </TableRow>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/WeightTolerance/ToleranceItem.js